<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="pagev"></a>For all of the military journalists, photographers, and Public Affairs staffers who tell the stories of these brave canine soldiers and the men and women who work alongside them</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?0c6ed612